import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  canAccess,
  getDefaultAllowedPath,
  getModuleForPath,
  hasAnyAccess,
  NO_ACCESS_PATH,
} from "../permissions";
import { selectAccessData, selectAccessReady } from "../redux/userSlice";

const PermissionGuard = ({ children }) => {
  const { pathname } = useLocation();
  const accessReady = useSelector(selectAccessReady);
  const accessData = useSelector(selectAccessData);
  const module = getModuleForPath(pathname);
  const isNoAccessPage = pathname === NO_ACCESS_PATH;

  if (!accessReady) {
    return (
      <div className="flex min-h-screen items-center justify-center px-6 text-sm text-[#667085]">
        Loading access...
      </div>
    );
  }

  if (!hasAnyAccess(accessData)) {
    return isNoAccessPage ? children : <Navigate to={NO_ACCESS_PATH} replace />;
  }

  if (isNoAccessPage) {
    const firstAllowedPath = getDefaultAllowedPath(pathname, accessData);
    return firstAllowedPath ? (
      <Navigate to={firstAllowedPath} replace />
    ) : (
      children
    );
  }

  if (!module || canAccess(module, accessData)) {
    return children;
  }

  const fallbackPath = getDefaultAllowedPath(pathname, accessData);
  return <Navigate to={fallbackPath || NO_ACCESS_PATH} replace />;
};

export default PermissionGuard;
